module.exports = __webpack_public_path__ + "static/media/retail.b73acdc0.svg";